<div class="alert alert-danger blinking-msg" style="position: absolute; z-index: 1;right: 0;top:150px" role="alert" *ngIf="userDetails?.isApproved == false">
    <h4 class="mb-0">{{'tooltips.messag1' | translate}}  <span style="text-decoration-line: underline; text-decoration-color: black;">
        <i class="fa-solid fa-phone"></i> 800 270</span> <br>
        <span *ngIf="userDetails?.remarks">
            <h4 class="mt-2">{{'tooltips.messag2' | translate}}.<br></h4>{{userDetails?.remarks[0]}}
        </span>
    </h4>
</div>
